import React, { useContext } from 'react';
import styles from './priceFacet.module.pcss';
import RangeSlider from '../../../../components/rangeSlider';
import { FacetData, FacetValueData, PriceSliderStyle } from '../../../../types';
import { ListerContext } from '../../listerContext';

interface PriceFacetProps {
  facet: FacetData;
  facetSelectionHandler: (facetValue: FacetValueData, facetData: FacetData) => void;
  sliderStyle: PriceSliderStyle;
  isExpanded: boolean;
  isDisabled: boolean;
}

function PriceFacet({
  facet,
  facetSelectionHandler,
  sliderStyle,
  isExpanded,
  isDisabled
}: PriceFacetProps): React.ReactElement {
  const [{ currentQuery }] = useContext(ListerContext);

  function pricesChanged(min: number, max: number): boolean {
    return min !== facet.selectedPriceLower || max !== facet.selectedPriceHigher;
  }

  function filterPrices(min: number, max: number): void {
    if (pricesChanged(min, max)) {
      const priceFacetValue = facet.values[0];
      priceFacetValue.query = {
        location: updateQueryLocation(currentQuery.location, facet.code, { minPrice: min, maxPrice: max })
      };
      priceFacetValue.selected = false;
      facetSelectionHandler(priceFacetValue, facet);
    }
  }

  return (
    <div className={styles['price-facet']}>
      <RangeSlider
        key={facet.code}
        min={facet.priceLower}
        max={facet.priceHigher}
        minLabel={facet.name}
        maxLabel={facet.name}
        currency="GBP"
        currentMin={facet.selectedPriceLower}
        currentMax={facet.selectedPriceHigher}
        sliderStyle={sliderStyle}
        visible={isExpanded}
        isDisabled={isDisabled}
        onRangeUpdate={(valueMin: number, valueMax: number): void => {
          filterPrices(valueMin, valueMax);
        }}
      />
    </div>
  );
}

/**
 * Looks for the price query parameter in the current query, replaces it
 * or adds it if does not exist.
 */
export function updateQueryLocation(
  location: string,
  facetCode: string,
  priceData: { minPrice: number; maxPrice: number }
): string {
  const matches = location.match(/fh_location=([^&]*)/);
  if (matches && matches.length > 1) {
    const priceRangeRegex = new RegExp(`/[0-9]+(.[0-9]{0,})?<${facetCode}<[0-9]+(.[0-9]{0,})?/{0,1}`);
    const priceEqualRegex = new RegExp(`/${facetCode}=[0-9]+(.[0-9]{0,})?/{0,1}`);

    const fhLocationSubQuery = decodeURIComponent(matches[1])
      .replace(priceRangeRegex, `/`)
      .replace(priceEqualRegex, `/`)
      .concat(`/${priceData.minPrice}<${facetCode}<${priceData.maxPrice}`);

    return location.replace(/fh_location=[^&]*/, `fh_location=${encodeURIComponent(fhLocationSubQuery)}`);
  }
  return location;
}

export default PriceFacet;
